module.exports = __webpack_public_path__ + "media/images/procedure_managements/what_is/img_5-55db3331b0963b21a0758dd562a6f6e6.png";